import { useState } from 'react';

import { CellTower as CellTowerIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import useSWRMutation from 'swr/mutation';

import { FormDialog } from '~components';
import { SkcDeviceCommand, SkcDeviceCommandForm, SkcDevicesService } from '~features/devices';
import { useSnackbar } from '~hooks';
import { PageLayout, PageLayoutProps } from '~layouts';

import './accessPageLayout.css';

interface UserAction {
	type: 'sendCommand';
}

const skcDevicesService = new SkcDevicesService();

const AccessPageLayout = (props: PageLayoutProps) => {
	const { t } = useTranslation();
	const { enqueueSuccessSnackbar, enqueueAxiosErrorSnackbar } = useSnackbar();

	const [userAction, setUserAction] = useState<UserAction | null>(null);

	const { trigger: triggerCommand, isMutating: isCommandMutating } = useSWRMutation(
		skcDevicesService.basePath,
		(_, { arg }: { arg: SkcDeviceCommand }) => {
			const { device, ...rest } = arg;
			return skcDevicesService.sendCommand(device.id, rest);
		},
		{
			onSuccess: () => {
				enqueueSuccessSnackbar(
					t(`actionMessageWasSendToResource`, {
						action: t('unlock'),
						resource: t('device'),
					})
				);
				setUserAction(null);
			},
			onError: (error) => enqueueAxiosErrorSnackbar(error),
		}
	);

	return (
		<>
			<PageLayout
				{...props}
				slotProps={{
					...props.slotProps,
					header: {
						...props.slotProps?.header,
						buttons: [
							{
								children: t('remoteAction'),
								startIcon: <CellTowerIcon />,
								onClick: () => setUserAction({ type: 'sendCommand' }),
							},
						],
					},
				}}
			/>
			<FormDialog
				title={t('remoteAction')}
				open={userAction?.type === 'sendCommand'}
				maxWidth='xs'
				onClose={() => setUserAction(null)}
				fullWidth
				saveLabel={t('ui.confirm')}
				loading={isCommandMutating}
			>
				<SkcDeviceCommandForm onSubmit={async (val) => triggerCommand(val)} />
			</FormDialog>
		</>
	);
};

export default AccessPageLayout;
